import React from "react";
import { Redirect } from "react-router-dom";
import NewsCarousel from "../../../components/member/info/newsCarousel";
import { Path } from "../../../constants/enum/path.emum";
import ListNews from "../../../components/setting/news/listNews";

const MemberInfo = () => {
  const user = JSON.parse(localStorage.getItem("user") ?? "false");

  if (user.role.name === "Admin") {
    return <Redirect to={Path.SCHEDULES} />;
  }
  return (
    <div className="container mt-1">
      <NewsCarousel />
      <ListNews />
    </div>
  );
};

export default MemberInfo;
